export default __webpack_public_path__ + "static/media/home-photography-img-02.6516a628.jpg";